import React from "react";
import TemplateSelector from "../TemplateSelector/TemplateSelector";
import { SceneEditor } from "../TemplateEditor";

import { WebIcon, MessageWarn } from "../../../Svg";

import {
  SceneWrapper,
  SingleSection,
  SectionHeader,
  SectionLabel,
  SectionContent
} from "./TemplateEditorContent.styled";
import { isOldDefaultTemplateStyle } from "../../TemplatePost__Preview/utils";
import { PreviewStore, withRefluxStore } from "../../../../../../Stores";
import { useTranslation } from "react-i18next";

const TemplateEditorContent = ({
  template,
  showVerticalImage,
  showTikTokVideoTemplate,
  isSnapchatChannel,
  inputProps,
  onChange,
  closeTemplateEditor,
  templateTypeSelected,
  // Store
  campaignData
}) => {
  const { t } = useTranslation();
  const showConfigureTemplate = templateTypeSelected === template.type;
  const isOldCampaign = isOldDefaultTemplateStyle(campaignData?.status, campaignData?.createdDate);

  return (
    <>
      <SingleSection>
        <SectionHeader>
          <WebIcon />
          <SectionLabel>{t("Select template")}</SectionLabel>
        </SectionHeader>
        <SectionContent>
          <TemplateSelector
            templateId={template.id}
            showVerticalImage={showVerticalImage}
            showTikTokVideoTemplate={showTikTokVideoTemplate}
            templateTypeSelected={templateTypeSelected}
          />
        </SectionContent>
      </SingleSection>
      {showConfigureTemplate && (
        <SingleSection>
          <SectionHeader>
            <MessageWarn />
            <SectionLabel>Configure Template</SectionLabel>
          </SectionHeader>
          <SectionContent>
            {template?.scenes?.map((scene, index) => (
              <SceneWrapper key={index}>
                <SceneEditor
                  scene={scene}
                  inputProps={inputProps}
                  onChange={onChange}
                  closeTemplateEditor={closeTemplateEditor}
                  showVerticalImage={showVerticalImage}
                  isSnapchatChannel={isSnapchatChannel}
                  isOldCampaign={isOldCampaign}
                  templateId={template.id}
                />
              </SceneWrapper>
            ))}
          </SectionContent>
        </SingleSection>
      )}
    </>
  );
};
export default withRefluxStore(TemplateEditorContent, [PreviewStore], ["campaignData"]);
